(function statusInfoControllerDefinition() {
    'use strict';

    angular.module('Status')
        .controller('StatusInfoController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'statusService', '$http', 'fileDownloader', 'authExtend',
            function statusInfoController($scope, config, $state, $translate, errors, statusService, $http, fileDownloader, auth) {

                $scope.load = function () {
                    $scope.releaseName = config.releaseName();
                    $scope.apis = {
                        wf: {
                            version: '', versionOk: false, success: false, statusOk: false, url: '', title: 'WF', keys: null, keysOk: false, dauVersion: {sql: null, mongo: null}},
                        edr: {
                            version: '', versionOk: false, success: false, statusOk: false, url: '', title: 'EDR', keys: null, keysOk: false, dauVersion: { sql: null, mongo: null } },
                        audit: {
                            version: '', versionOk: false, success: false, statusOk: false, url: '', title: 'Audit', keys: null, keysOk: false, dauVersion: { sql: null, mongo: null } },
                        auth: {
                            version: '', versionOk: false, success: false, statusOk: false, url: '', title: 'Auth', keys: null, keysOk: false, dauVersion: { sql: null, mongo: null } },
                        //notif: { version: '', versionOk: false, success: false, statusOk: false, url: '', title: 'Notif', keys: null, dauVersion: {sql: null, mongo: null} },
                        cpp: {
                            version: '', versionOk: false, success: false, statusOk: false, url: '', title: 'CPP', keys: null, keysOk: false, dauVersion: { sql: null, mongo: null } },
                        process: {
                            version: '', versionOk: false, success: false, statusOk: false, url: '', title: 'Process', keys: null, keysOk: false, dauVersion: { sql: null, mongo: null } }
                    };

                    if (!auth.getCreationOuId()) {
                        $scope.showLog = true;
                    }

                    $scope.getWfInfo();
                    $scope.getEdrInfo();
                    $scope.getAuditInfo();
                    $scope.getAuthInfo();
                    //$scope.getNotifInfo();
                    $scope.getCppInfo();
                    $scope.getProcessInfo();
                    $scope.getAssemblyVersion();
                };

                $scope.getWfInfo = function () {
                    statusService.getWfVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.wf.version = result.value;
                            $scope.apis.wf.versionOk = true;
                        }
                    }, function (error) {
                        $scope.apis.wf.version = error.data.message;
                    });

                    statusService.getWfStatus().then(function (result) {
                        if (result) {
                            $scope.apis.wf.statusOk = result.success;
                        }
                    }, function (error) {
                        $scope.apis.wf.status = error.data.message;
                    });

                    $scope.apis.wf.url = statusService.getWfUrl();
                };

                $scope.getEdrInfo = function () {
                    statusService.getEdrVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.edr.version = result.value;
                            $scope.apis.edr.versionOk = true;
                        }
                    }, function (error) {
                        $scope.apis.edr.version = error.data.message;
                    });

                    statusService.getEdrStatus().then(function (result) {
                        if (result) {
                            $scope.apis.edr.statusOk = result.success;
                        }
                    }, function (error) {
                        $scope.apis.edr.status = error.data.message;
                    });

                    $scope.apis.edr.url = statusService.getEdrUrl();
                };

                $scope.getAuditInfo = function () {

                    statusService.getAuditVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.audit.version = result.value;
                            $scope.apis.audit.versionOk = true;
                        }
                    }, function (error) {
                        $scope.apis.audit.version = error.data.message;
                    });

                    statusService.getAuditStatus().then(function (result) {
                        if (result) {
                            $scope.apis.audit.statusOk = result.success;
                        }
                    }, function (error) {
                        $scope.apis.audit.status = error.data.message;
                    });

                    $scope.apis.audit.url = statusService.getAuditUrl();
                };

                $scope.getAuthInfo = function () {
                    statusService.getAuthVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.auth.version = result.value;
                            $scope.apis.auth.versionOk = true;
                        }
                    }, function (error) {
                        $scope.apis.auth.version = error.data.message;
                    });

                    statusService.getAuthStatus().then(function (result) {
                        if (result) {
                            $scope.apis.auth.statusOk = result.success;
                        }
                    }, function (error) {
                        $scope.apis.audit.status = error.data.message;
                    });

                    $scope.apis.auth.url = statusService.getAuthUrl();
                };

                $scope.getNotifInfo = function () {
                    statusService.getNotifVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.notif.version = result.value;
                            $scope.apis.notif.versionOk = true;
                        }
                    }, function (error) {
                        $scope.apis.notif.version = error.data.message;
                    });

                    statusService.getNotifStatus().then(function (result) {
                        if (result) {
                            $scope.apis.notif.statusOk = result.success;
                        }
                    }, function (error) {
                        $scope.apis.notif.status = error.data.message;
                    });

                    $scope.apis.notif.url = statusService.getNotifUrl();
                };


                $scope.getCppInfo = function () {
                    statusService.getCppVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.cpp.version = result.value;
                            $scope.apis.cpp.versionOk = true;
                        }
                    }, function (error) {
                        $scope.apis.cpp.version = error.data.message;
                    });

                    statusService.getCppStatus().then(function (result) {
                        if (result) {
                            $scope.apis.cpp.statusOk = result.success;
                        }
                    }, function (error) {
                        $scope.apis.cpp.status = error.data.message;
                    });

                    $scope.apis.cpp.url = statusService.getCppUrl();
                };

                $scope.getProcessInfo = function () {
                    statusService.getProcessVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.process.version = result.value;
                            $scope.apis.process.versionOk = true;
                        }
                    }, function (error) {
                        $scope.apis.process.version = error.data.message;
                    });

                    statusService.getProcessStatus().then(function (result) {
                        if (result) {
                            $scope.apis.process.statusOk = result.success;
                        }
                    }, function (error) {
                        $scope.apis.process.status = error.data.message;
                    });

                    $scope.apis.process.url = statusService.getProcessUrl();
                };

                $scope.getAssemblyVersion = function () {
                    $http({
                        method: 'GET',
                        url: 'Home/GetVersion'
                    }).then(function successCallback(response) {
                        $scope.assemblyVersion = response.data;
                    }, function errorCallback(response) {
                        // or server returns response with an error status.
                    });
                };

                $scope.downloadLog = function (system) {
                    return statusService.downloadLog(system).then(function (result) {
                        var success = fileDownloader.saveAs(result, 'log_' + system + '.txt');
                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.getWfKeyInfo = function () {
                    statusService.getWfKeyInfo().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.wf.keys = result.value;
                            $scope.apis.wf.keysOk = true;
                        }
                    }, function (error) {
                        $scope.apis.wf.keys = error.data.message;
                    });
                };

                $scope.getEdrKeyInfo = function () {
                    statusService.getEdrKeyInfo().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.edr.keys = result.value;
                            $scope.apis.edr.keysOk = true;
                        }
                    }, function (error) {
                        $scope.apis.edr.keys = error.data.message;
                    });
                };

                $scope.getAuditKeyInfo = function () {
                    statusService.getAuditKeyInfo().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.audit.keys = result.value;
                            $scope.apis.audit.keysOk = true;
                        }
                    }, function (error) {
                        $scope.apis.audit.keys = error.data.message;
                    });
                };

                $scope.getAuthKeyInfo = function () {
                    statusService.getAuthKeyInfo().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.auth.keys = result.value;
                            $scope.apis.auth.keysOk = true;
                        }
                    }, function (error) {
                            $scope.apis.auth.keys = error.data.message;
                    });
                };

                $scope.getNotifKeyInfo = function () {
                    statusService.getNotifKeyInfo().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.notif.keys = result.value;
                            $scope.apis.notif.keysOk = true;
                        }
                    }, function (error) {
                            $scope.apis.notif.keys = error.data.message;
                    });
                };

                $scope.getCppKeyInfo = function () {
                    statusService.getCppKeyInfo().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.cpp.keys = result.value;
                            $scope.apis.cpp.keysOk = true;
                        }
                    }, function (error) {
                            $scope.apis.cpp.keys = error.data.message;
                    });
                };

                $scope.getProcessKeyInfo = function () {
                    statusService.getProcessKeyInfo().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.process.keys = result.value;
                            $scope.apis.process.keysOk = true;
                        }
                    }, function (error) {
                            $scope.apis.process.keys = error.data.message;
                    });
                };

                $scope.getWfDauVersion = function () {
                    statusService.getWfDauMongoVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.wf.dauVersion.mongo = result.value;
                        }
                    }, function (error) {
                        $scope.apis.wf.status = error.data.message;
                    });
                };

                $scope.getEdrDauVersion = function () {
                    statusService.getEdrDauSqlVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.edr.dauVersion.sql = result.value;
                        }
                    }, function (error) {
                        $scope.apis.edr.status = error.data.message;
                    });

                    statusService.getEdrDauMongoVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.edr.dauVersion.mongo = result.value;
                        }
                    }, function (error) {
                        $scope.apis.edr.status = error.data.message;
                    });
                };

                $scope.getAuditDauVersion = function () {
                    statusService.getAuditDauMongoVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.audit.dauVersion.mongo = result.value;
                        }
                    }, function (error) {
                        $scope.apis.audit.status = error.data.message;
                    });
                };

                $scope.getAuthDauVersion = function () {
                    statusService.getAuthDauSqlVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.auth.dauVersion.sql = result.value;
                        }
                    }, function (error) {
                        $scope.apis.auth.status = error.data.message;
                    });
                };

                $scope.getNotifDauVersion = function () {
                    statusService.getNotifDauMongoVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.notif.dauVersion.mongo = result.value;
                        }
                    }, function (error) {
                        $scope.apis.notif.status = error.data.message;
                    });
                };

                $scope.getCppDauVersion = function () {
                    statusService.getCppDauSqlVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.cpp.dauVersion.sql = result.value;
                        }
                    }, function (error) {
                        $scope.apis.cpp.status = error.data.message;
                    });
                };

                $scope.getProcessDauVersion = function () {
                    statusService.getProcessDauMongoVersion().then(function (result) {
                        if (result && result.success) {
                            $scope.apis.process.dauVersion.mongo = result.value;
                        }
                    }, function (error) {
                        $scope.apis.process.status = error.data.message;
                    });
                };

                $scope.getKeyInfo = function (api) {

                    if (api.keysOk) {
                        return ;
                    }

                    switch (api) {
                        case $scope.apis.wf: $scope.getWfKeyInfo(); break;
                        case $scope.apis.edr: $scope.getEdrKeyInfo(); break;
                        case $scope.apis.audit: $scope.getAuditKeyInfo(); break;
                        case $scope.apis.auth: $scope.getAuthKeyInfo(); break;
                        case $scope.apis.notif: $scope.getNotifKeyInfo(); break;
                        case $scope.apis.cpp: $scope.getCppKeyInfo(); break;
                        case $scope.apis.process: $scope.getProcessKeyInfo(); break;
                    }
                };

                $scope.getDauVersion = function (api) {

                    if (api.dauVersion.mongo || api.dauVersion.sql) {
                        return;
                    }

                    switch (api) {
                        case $scope.apis.wf: $scope.getWfDauVersion(); break;
                        case $scope.apis.edr: $scope.getEdrDauVersion(); break;
                        case $scope.apis.audit: $scope.getAuditDauVersion(); break;
                        case $scope.apis.auth: $scope.getAuthDauVersion(); break;
                        case $scope.apis.notif: $scope.getNotifDauVersion(); break;
                        case $scope.apis.cpp: $scope.getCppDauVersion(); break;
                        case $scope.apis.process: $scope.getProcessDauVersion(); break;
                    }
                };

                $scope.load();
            }])
})();